export default function Experience() {
    return (
        <div className="overflow-x-auto">
            <h1 className="text-3xl font-bold">Experience</h1>
            <br/>
            <table className="table table-sm">
                {/* head */}
                <thead>
                <tr>
                    <th>Company</th>
                    <th>Job</th>
                    <th>Description</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {/* row 1 */}
                <tr >
                    <td><a href="https://beamy.xyz/" target="_blank" rel="noopener noreferrer">Beamy</a></td>
                    <td>Product Engineer Intern</td>
                    <td>During my internship, I developed the first version of a desktop agent deployed to 200,000 enterprise users.
                        I worked on co-usage analysis methods, collaborated with internal teams, and presented technical results to senior leadership.
                        The role required autonomy, rapid learning of new technologies, and translating technical work into insights for product development.</td>
                    <td>September 2025 - February 2026</td>
                </tr>
                <tr >
                    <td><a href="https://www.advanced-schema.com/" target="_blank" rel="noopener noreferrer">Advanced Schema</a></td>
                    <td>Full Stack Developer Intern</td>
                    <td>Design and development of data manipulation applications using SCRUM methodology</td>
                    <td>April - July 2024</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}